export const getLoyaltyQuery = () => `query
{
  profile {
    loyaltyProgram {
      isPlatinumForLife
      points
      status
    }
  }
}`;
export const getLoyaltyProgramQuery = () => `
  query {
    loyaltyProgram {
      status
      threshold
    }
    loyaltyProgramSimulation {
      currency
    }
  }`;
